import { useNavigate } from "react-router-dom";
import useAuthUser from "../../hooks/useAuthUser";

const PrivateRoute = ({ element, requiredRoles, fallback }) => {
  const { loggedInUser } = useAuthUser();
  const navigate = useNavigate();

  if (loggedInUser === null) {
    const token = localStorage.getItem("token");
    if (token) {
      return <div>Loading...</div>;
    }
    navigate("/", { replace: true });
    return null;
  }

  if (requiredRoles && !requiredRoles.includes(Number(loggedInUser.role))) {
    window.location.href = fallback;
    return null;
  }

  return element;
};
export default PrivateRoute;
